import * as angular from 'angular';

"use strict";
angular.module('ConfigurationModule', []);

export default 'ConfigurationModule';
